/**
 * Accessibility helpers.
 */

/**
 * Returns the props needed to make a non-native element (div/span/li/...) behave
 * as an accessible button: it exposes the `button` role, becomes focusable and
 * activates on Enter/Space — mirroring the click behaviour for keyboard users.
 *
 * Usage (Vue TSX):
 *   <div {...clickable(() => doSomething())}>...</div>
 *
 * Replaces a bare `onClick` on static elements, which trips the a11y rules
 * (click-events-have-key-events / no-static-element-interactions).
 */
export function clickable(onActivate: (event: Event) => void) {
  return {
    role: "button",
    tabindex: 0,
    onClick: onActivate,
    onKeydown: (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onActivate(event);
      }
    },
  };
}
